import React from "react";
import { Router, Route, Switch } from "react-router-dom";
import { ROUTES } from "./routes";
import viewRoutes from "./routes/viewRoutes";
import { DATA } from "./myanfinviz";
import SearchBar from "./components/SearchBar";
import TableView from "./components/TableView";
import Home from "./components/Home";
import { Layout, Menu, Breadcrumb, Button } from "antd";
import { Input } from "antd";
import {
  DesktopOutlined,
  PieChartOutlined,
  FileOutlined,
  TeamOutlined,
  UserOutlined,
  HomeOutlined,
  FileSearchOutlined,
  DotChartOutlined,
  SearchOutlined,
  TableOutlined,
  FileUnknownOutlined,
  FundViewOutlined,
  GlobalOutlined,
} from "@ant-design/icons";
import NoPageFound from "./components/NoPageFound";
import ExploreDashboard from "./components/ExploreDashboard";
import history from "./history";
const { Header, Content, Footer, Sider } = Layout;
const { SubMenu } = Menu;
class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      collapsed: false,
      currentRoute: ROUTES.BASE.ENTRY,
      selectedMenuKey: "home",
    };
  }
  componentDidMount = () => {};

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  };

  navigate = (route, menuKey) => {
    this.setState(
      { currentRoute: route, selectedMenuKey: menuKey },
      console.log("navigate", this.state)
    );
    console.log("navigate", route.toString(), ":", typeof route);
    console.log("navigate", this.props);
    history.push(route);
  };

  setSelectedMenuKey = (key) => {
    this.setState({
      selectedMenuKey: key,
    });
  };

  render() {
    console.log("App.js state", this.state);
    return (
      <div className="App">
        <Layout style={{ minHeight: "100vh" }}>
          <Sider id="app-sider" onCollapse={this.onCollapse}>
            <div className="p-3">
              <Input placeholder="Search ..." prefix={<SearchOutlined />} />
            </div>
            <Menu
              defaultOpenKeys={["explore_sub", "tables_sub"]}
              theme="dark"
              mode="inline"
              selectable={false}
            >
              <Menu.Item
                onClick={() => this.navigate(ROUTES.BASE.ENTRY, "home")}
                key="home"
                icon={<HomeOutlined />}
              >
                Home
              </Menu.Item>

              <SubMenu
                key="explore_sub"
                icon={<FileSearchOutlined />}
                title="Explore Dashboard"
              >
                <Menu.Item
                  key="search"
                  icon={<SearchOutlined />}
                  onClick={() => {
                    this.navigate(ROUTES.EXPLORE.SEARCH, "search");
                  }}
                >
                  Search
                </Menu.Item>
                <Menu.Item
                  key="table"
                  icon={<TableOutlined />}
                  onClick={() => {
                    this.navigate(ROUTES.EXPLORE.TABLE, "table");
                  }}
                >
                  Table
                </Menu.Item>
                <Menu.Item
                  key="visual"
                  icon={<FundViewOutlined />}
                  onClick={() => {
                    this.navigate(ROUTES.EXPLORE.VISUAL, "visual");
                  }}
                >
                  Visual
                </Menu.Item>
                <Menu.Item
                  key="compare"
                  icon={<FileUnknownOutlined />}
                  onClick={() => {
                    this.navigate(ROUTES.EXPLORE.COMPARE, "compare");
                  }}
                >
                  Compare
                </Menu.Item>
              </SubMenu>

              <SubMenu
                key="tables_sub"
                icon={<FileSearchOutlined />}
                title="Tables Quick Access"
              >
                <Menu.Item
                  key="countries"
                  icon={<GlobalOutlined />}
                  onClick={() => {
                    this.navigate(ROUTES.TABLES.COUNTRIES, "countries");
                  }}
                >
                  Countries
                </Menu.Item>{" "}
                <Menu.Item
                  key="countries"
                  icon={<UserOutlined />}
                  onClick={() => {
                    this.navigate(ROUTES.TABLES.INVESTORS, "investors");
                  }}
                >
                  Investors
                </Menu.Item>
              </SubMenu>
              <Menu.Item
                key={"analysis"}
                icon={<DotChartOutlined />}
                selectable={false}
              >
                <a
                  href="https://myanfinviz-analysis.web.app/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Analysis
                </a>
              </Menu.Item>
            </Menu>
          </Sider>
          <Layout className="site-layout">
            <Content className="p-3">
              <h1 className="p-2 font-weight-bold text-primary text-center">
                Myanmar Financial Visualizer
              </h1>
              <div className="display-content p-3">
                <Switch>
                  <Route
                    key="5"
                    exact
                    path={"/"}
                    component={(props) => <Home />}
                  />
                  <Route
                    key="10"
                    exact
                    path={"/:page"}
                    component={(props) => <Home {...props} />}
                  />
                  <Route
                    key="20"
                    path={ROUTES.EXPLORE.ENTRY + "/:mode"}
                    exact
                    component={(props) => <ExploreDashboard {...props} />}
                  />
                  <Route
                    key="30"
                    path={ROUTES.TABLES.ENTRY + "/:column"}
                    exact
                    component={(props) => <TableView {...props} />}
                  />
                  <Route
                    key="40"
                    path={ROUTES.TABLES.ENTRY + "/:column/:key"}
                    exact
                    component={(props) => <TableView {...props} />}
                  />
                  <Route path={"/*"} component={NoPageFound} />
                </Switch>
              </div>
            </Content>
            <Footer style={{ textAlign: "center" }}>Myanmarfinviz</Footer>
          </Layout>
        </Layout>
      </div>
    );
  }
}

export default App;
